import React, { useEffect } from 'react';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import { Instagram } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const InstagramAuth: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Component mounted - authentication is handled by PrivateRoute
    console.log('InstagramAuth component mounted');
  }, []);

  const handleInstagramLogin = () => {
    // Redirect to Instagram OAuth
    window.location.href = '/auth/instagram';
  };

  const handleSkip = () => {
    // Skip Instagram auth and go to dashboard
    navigate('/app/dashboard');
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <Instagram sx={{ fontSize: 60, color: '#E4405F', mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Instagram Bağlantısı
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Facebook hesabınız başarıyla bağlandı! Şimdi Instagram hesabınızı da bağlayarak 
            Instagram mesajlarını yönetebilirsiniz.
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleInstagramLogin}
              sx={{
                backgroundColor: '#E4405F',
                '&:hover': {
                  backgroundColor: '#C13584'
                }
              }}
            >
              Instagram ile Bağlan
            </Button>
            
            <Button
              variant="outlined"
              size="large"
              onClick={handleSkip}
            >
              Şimdilik Atlayın
            </Button>
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
            Instagram bağlantısı olmadan da Facebook mesajlarını yönetebilirsiniz.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default InstagramAuth;
